export const LOADING_FORM_PROVIDER = 'LOADING_FORM_PROVIDER';
export const ERROR_FORM_PROVIDER = 'ERROR_FORM_PROVIDER';
export const RESET_FORM_PROVIDER = 'RESET_FORM_PROVIDER';
